import { Observable } from 'rxjs';

import { CloudRoom } from '@shure/cloud/shared/models/devices';

export abstract class CloudRoomsApiService {
	public abstract cloudRoomsLoadingComplete$: Observable<boolean>;
	public abstract cloudRoomAdded$: Observable<CloudRoom>;
	public abstract cloudRoomRemoved$: Observable<string>;
	public abstract cloudRoomSnapshot$: Observable<CloudRoom>;
}
